import { render, staticRenderFns } from "./config.vue?vue&type=template&id=514c6265&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=514c6265&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c6265",
  null
  
)

export default component.exports